<template>
    <div
        class="yp-header-alert bg-yellow-100 flex itemss-center justify-center z-100 w-full text-sm py-2 px-4"
        :class="variants[variant]"
    >
        <slot></slot>
    </div>
</template>

<script setup>
defineProps({
    variant: {
        type: String,
        default: 'warning',
        validator: (value) => ['warning'].includes(value),
    },
});

const variants = {
    warning: 'bg-feedback-warning_light text-feedback-warning_medium',
};
</script>
